import React, { FC } from 'react';
import { ResponsivePie, PieSvgProps } from '@nivo/pie';

const PieChart: FC<PieSvgProps> = props => <ResponsivePie {...props} />;

export default PieChart;
